var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360.5 360.5",
    style: {
      enableBackground: "new 0 0 360.5 360.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E11936;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.7,0H13.1C7.3,0,2.6,4.7,2.6,10.4V94c0,5.8,4.7,10.4,10.4,10.4h83.6c5.8,0,10.4-4.7,10.4-10.4V10.4 C107.1,4.7,102.4,0,96.7,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222,0h-83.6C132.7,0,128,4.7,128,10.4V94c0,5.8,4.7,10.4,10.4,10.4H222c5.8,0,10.4-4.7,10.4-10.4V10.4 C232.5,4.7,227.8,0,222,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.7,125.4H13.1c-5.8,0-10.4,4.7-10.4,10.4v83.6c0,5.8,4.7,10.4,10.4,10.4h83.6c5.8,0,10.4-4.7,10.4-10.4 v-83.6C107.1,130.1,102.4,125.4,96.7,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222,125.4h-83.6c-5.8,0-10.4,4.7-10.4,10.4v83.6c0,5.8,4.7,10.4,10.4,10.4H222c5.8,0,10.4-4.7,10.4-10.4 v-83.6C232.5,130.1,227.8,125.4,222,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M347.4,0h-83.6c-5.8,0-10.4,4.7-10.4,10.4V94c0,5.8,4.7,10.4,10.4,10.4h83.6c5.8,0,10.4-4.7,10.4-10.4V10.4 C357.9,4.7,353.2,0,347.4,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M347.4,125.4h-83.6c-5.8,0-10.4,4.7-10.4,10.4v83.6c0,5.8,4.7,10.4,10.4,10.4h83.6c5.8,0,10.4-4.7,10.4-10.4 v-83.6C357.9,130.1,353.2,125.4,347.4,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.7,256H13.1c-5.8,0-10.4,4.7-10.4,10.4V350c0,5.8,4.7,10.4,10.4,10.4h83.6c5.8,0,10.4-4.7,10.4-10.4 v-83.6C107.1,260.7,102.4,256,96.7,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222,256h-83.6c-5.8,0-10.4,4.7-10.4,10.4V350c0,5.8,4.7,10.4,10.4,10.4H222c5.8,0,10.4-4.7,10.4-10.4v-83.6 C232.5,260.7,227.8,256,222,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M347.4,256h-83.6c-5.8,0-10.4,4.7-10.4,10.4V350c0,5.8,4.7,10.4,10.4,10.4h83.6c5.8,0,10.4-4.7,10.4-10.4 v-83.6C357.9,260.7,353.2,256,347.4,256z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.27fcaf9879c8a57def7c6d06a1e9e63e.svg";
export { ForwardRef as ReactComponent };